import styled from 'styled-components'

import { helpers, toRem } from 'styles'

export const Amount = styled.div`
	color: ${helpers.color.textHeader};
	font-size: ${toRem(32)};
	font-weight: 600;
	margin: 2px 0;
`
